import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Loader } from "../../packages/shared";
import { COUNTRY_LIST, Helper } from "../../utils";
import { ALL_ABBVIE_PRO_SYSTEM_SETTINGS, ALL_ALLERGAN_PRO_SYSTEM_SETTINGS } from "./query";
import { SectionTitle } from "../shared";

const FormList = ({ appName }) => {
    const currentUser = useSelector((state) => state.users.currentUser);
    const [countryList, setCountryList] = useState(currentUser.country);

    const QUERY =
        (appName === "abbvie-pro" && ALL_ABBVIE_PRO_SYSTEM_SETTINGS) ||
        (appName === "allergan-pro" && ALL_ALLERGAN_PRO_SYSTEM_SETTINGS);
    const DATAPATH =
        (appName === "abbvie-pro" && "allAbbvieProSystemSettings") ||
        (appName === "allergan-pro" && "allAllerganProSystemSettings");

    const { loading, data } = useQuery(gql(QUERY));

    useEffect(() => {
        if (currentUser.userType === 99 && data) {
            if (data?.[DATAPATH].nodes.length > 0) {
                setCountryList([...new Set(data?.[DATAPATH]?.nodes.map((item) => item.country))]);
            }
        } else if (currentUser.userType === 1) {
            setCountryList(currentUser.country);
        }
    }, [data, currentUser]);

    return (
        <>
            {loading && <Loader />}

            <SectionTitle
                title={`${Helper.toTitleCase(appName)} Form List`}
                buttonUrl={`/${appName}/forms/create`}
                backUrl={`/${appName}`}
            />

            <div className="accordion mt-5" id="accordionFormList">
                <div className="card">
                    <div className="card-header">
                        <button
                            className="btn btn-block btn-link font-weight-bold text-decoration-none text-left"
                            type="button"
                        >
                            Country List
                        </button>
                    </div>
                </div>

                {countryList.length > 0 ? (
                    countryList.map((country, index) => {
                        const formList = data?.[DATAPATH]?.nodes.filter(
                            (item) => item.country === country
                        );

                        if (formList && formList.length > 0) {
                            return (
                                <div key={index} className="card">
                                    <div className="card-header">
                                        <button
                                            className="btn btn-block btn-link font-weight-bold text-decoration-none text-left text-body text-capitalize"
                                            type="button"
                                            data-toggle="collapse"
                                            data-target={`#${country}`}
                                            aria-expanded="true"
                                            aria-controls={country}
                                        >
                                            {COUNTRY_LIST[country] || country}
                                        </button>
                                    </div>
                                    <div
                                        id={country}
                                        className="collapse"
                                        data-parent="#accordionFormList"
                                    >
                                        <div className="card-body">
                                            <div className="list-group mx-auto">
                                                <div className="list-group-item list-group-item-action bg-light font-weight-bold">
                                                    Form List
                                                </div>
                                                {formList.map((item) => (
                                                    <Link
                                                        key={item.formKey}
                                                        className="list-group-item list-group-item-action"
                                                        to={`/${appName}/forms/${item.formKey}`}
                                                    >
                                                        {item.formText}
                                                    </Link>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        return null;
                    })
                ) : (
                    <div className="card">
                        <div className="card-body">
                            {!loading && (
                                <p className="font-weight-normal text-danger">
                                    No country permission found!!!
                                </p>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default FormList;
